/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:48:32                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 16:31:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * LanguageListItem: Display language list item
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import Flag from "../../flag/Flag";
import LanguagesAdminActions from "../../../views/super-admin/views/settings/tabs/Languages/LanguagesAdminActions";
/***/

/**
* LanguageListItem: Display language list item
* @param language - Language data
* @param onClick - On click event
* @param isLast - Is last item 
*/
export default function LanguageListItem({
  language,
  onClick,
  onChange,
  isLast = false
}: {
  language: EasyTech.Language,
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean
}) {
  return (
    <tr className={`page-list-item ${isLast && "last"}`} onClick={() => onClick && onClick()}>
      <td>
        <div className="flex gap-2 items-center">
          <Flag isoCode={language.isoCode}/>
          <Typography>{language.label}</Typography>
        </div>
      </td>
      
      <td>{language.isoCode}</td>

      <td>{(language.default ?? language.isDefault) ? "Yes" : "No"}</td>

      <td>{language.enabled ? "Yes" : "No"}</td>

      <td><LanguagesAdminActions lang={language} onChange={onChange} /></td>
    </tr>
  );
}
/***/
